// extracted by mini-css-extract-plugin
export default {"wrapper":"ListMovies_wrapper__3-Ds8","content":"ListMovies_content__6vi5o"};